import { IPageViewModelStandard } from "@/types/models/ContentPageViewModel.interface";

/**
 * Mock Generation Genius standards data
 * This will be replaced with real data from the content-document endpoint
 * when DISCO-1643 is complete
 */
export const getGeniusStandardsMockData = (): IPageViewModelStandard[] => {
  return [
    {
      id: "ck0tyi1o41jx7i6p7rqg93dyq",
      name: "WH.6.4.1",
      description:
        "Discuss the connections between geography and the development of city-states in the region of the Aegean Sea, including patterns of trade and commerce among Greek city-states and within the wider Mediterranean region.",
      regions: [],
    },
    {
      id: "ck0tyi30o1jxri6p7woj8ahx3",
      name: "WH.6.4.2",
      description:
        "Trace the transition from tyranny and oligarchy to early democratic forms of government and back to dictatorship in ancient Greece, including the significance of the invention of the idea of citizenship (e.g., from Pericles' Funeral Oration).",
      regions: [],
    },
    {
      id: "ck0tyki2u1kz2i6p7p4el43i2",
      name: "WH.7.10.1",
      description:
        "Discuss the roots of the Scientific Revolution (e.g., Greek rationalism; Jewish, Christian, and Muslim science; Renaissance humanism; new knowledge from global exploration).",
      regions: [],
    },
    {
      id: "ck0tyknoo1l1ii6p75wgrkuxw",
      name: "WH.7.11.4",
      description:
        "Explain how the main ideas of the Enlightenment can be traced back to such movements as the Renaissance, the Reformation, and the Scientific Revolution and to the Greeks, Romans, and Christianity.",
      regions: [],
    },
  ];
};
